export const EXTERNAL_LINKS = {
  linkedin: 'https://www.linkedin.com/in/jasminzeng',
  github: 'https://github.com/Jasmineprogrammiert',
};

export const PROFILE = {
  name: 'Jasmine Zeng',
  title: 'Full-stack software engineer',
  location: 'Hong Kong · Open to relocation',
  introduction: 'I build web applications and the services behind them. I work across user interfaces, APIs, and databases.',
  skills: ['Java / Spring Boot', 'C# / ASP.NET Core', 'TypeScript / React', 'SQL / PostgreSQL'],
};

// Public summaries only: keep client identities, internal systems, and incidents private.
export const CAREER = [
  {
    company: 'Toppan Security',
    location: 'Hong Kong',
    role: 'Software Developer',
    start: '2025-11',
    period: 'Nov 2025 — Present',
    description: 'I develop web applications and backend services. My work includes APIs, authentication, databases, performance improvements, and production deployments.',
    technologies: 'Java · Spring Boot · C# · ASP.NET Core · React · PostgreSQL',
  },
  {
    company: 'Ironfly Technologies',
    location: 'Hong Kong',
    role: 'Software Engineer',
    start: '2024-06',
    end: '2025-11',
    period: 'Jun 2024 — Nov 2025',
    description: 'Built features and API integrations for trading and wealth-management products, working across TypeScript applications, financial data, and user-facing workflows.',
    technologies: 'TypeScript · Angular · APIs',
  },
];

export const LEARNING = {
  title: 'Ongoing learning',
  description: 'I\'m learning more about data structures and algorithms, Java and Spring Boot, Docker, and Kubernetes through books, roadmaps, and hands-on practice.',
};

export const EDUCATION = [
  { qualification: 'Bachelor of Business Administration in Marketing', institution: 'The Hong Kong Polytechnic University', period: '2021 — 2024' },
  { qualification: 'Full-Stack Web Development', institution: 'Xccelerate', period: '2022', description: 'Completed during my university summer break. I built a hiking blog shortly afterwards; it is no longer maintained.' },
  { qualification: 'Associate of Business Administration in Financial Services', institution: 'City University of Hong Kong', period: '2019 — 2021' },
];

export const PROJECTS = [
  {
    name: 'HKID Watcher',
    category: 'Appointment availability alerts',
    description: 'A Python tool that checks the Immigration Department\'s published HKID appointment availability and sends alerts for dates on or before a chosen date. It saves state between runs, backs off after failures, and has automated tests. Booking is manual.',
    technologies: 'Python · GitHub Actions · pytest',
    href: 'https://github.com/Jasmineprogrammiert/hkid-bot',
    linkText: 'View source',
  },
];

export const INTERESTS = [
  { name: 'Outdoors', description: 'Hiking and travelling.' },
  { name: 'Languages', description: 'English, Cantonese, and Mandarin; continuing to learn German and French.' },
  { name: 'Art & books', description: 'Painting landscapes in oils and reading.' },
];

export const FOOTER_TEXT = `© ${new Date().getFullYear()} Jasmine Zeng`;